var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageDefaultLayout',{attrs:{"title":"GYYMについて"}},[_c('section',[_c('div',{staticClass:"my-5"},[_c('AboutGyyms')],1),_c('div',{staticClass:"mx-8 pt-7 mt-5 mb-16 lg:mx-22"},[_c('UsageFlows',{attrs:{"is-pc-single-column":true}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }